import { DatePicker as AntDatePicker } from "antd";
import type { Moment } from "moment-timezone";
import momentGenerateConfig from "rc-picker/lib/generate/moment";

export const DatePickerBase = AntDatePicker.generatePicker<Moment>(momentGenerateConfig);

export const DatePicker = DatePickerBase;
